import { render, staticRenderFns } from "./PersonalInfoCard.vue?vue&type=template&id=0427023b&scoped=true&"
import script from "./PersonalInfoCard.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfoCard.vue?vue&type=style&index=0&id=0427023b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0427023b",
  null
  
)

export default component.exports